import { Dispatch, type FC } from 'react';

import { TemplateSettings } from 'modules/map/components/daily-dish/types';
import { SettingsAction } from 'modules/map/components/daily-dish/reducer';
import FontStyleSelector from 'modules/map/components/daily-dish/components/template-settings-panel/FontStyleSelector';

interface FontStylesSelectorProps {
  settings: TemplateSettings;
  dispatch: Dispatch<SettingsAction>;
}

const FontStylesSelector: FC<FontStylesSelectorProps> = (props) => {
  const { settings, dispatch } = props;

  return (
    <>
      <FontStyleSelector
        label="Tiêu đề tuần"
        section="weekTitle"
        settings={settings}
        dispatch={dispatch}
      />
      <FontStyleSelector
        label="Tiêu đề tuần phụ"
        section="subWeekTitle"
        settings={settings}
        dispatch={dispatch}
      />
      <FontStyleSelector
        label="Tiêu đề ngày"
        section="weekdayTitle"
        settings={settings}
        dispatch={dispatch}
      />
      <FontStyleSelector
        label="Nội dung"
        section="content"
        settings={settings}
        dispatch={dispatch}
      />
    </>
  );
};

export default FontStylesSelector;
